var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStatuspatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3DEE99"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9999,
    cy: 19.9999,
    r: 15.2941,
    fill: "#3DEE99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0196 24.5711C28.0171 23.1963 26.7154 22.08 25.218 21.3109C23.7205 20.5418 22.0686 20.141 20.3935 20.1405C18.7183 20.14 17.0661 20.5397 15.5682 21.3078C14.0703 22.076 12.7679 23.1914 11.7646 24.5655C12.7628 25.9466 14.0631 27.0689 15.5611 27.8423C17.0591 28.6158 18.7132 29.019 20.3907 29.0195C22.0683 29.0201 23.7226 28.618 25.2211 27.8454C26.7196 27.0729 28.0205 25.9515 29.0196 24.5711Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3939 18.7199C22.6918 18.7199 24.5546 16.8118 24.5546 14.458C24.5546 12.1042 22.6918 10.196 20.3939 10.196C18.096 10.196 16.2332 12.1042 16.2332 14.458C16.2332 16.8118 18.096 18.7199 20.3939 18.7199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatuspatient);
export default __webpack_public_path__ + "static/media/ic_statuspatient.7147ff6e415b3c5663c3fe6b1b5f124b.svg";
export { ForwardRef as ReactComponent };